import React, { Component } from 'react';
import axios from 'axios';


class AddExam extends Component {
    state = {
        // isActive: false,
        windowHeight: window.innerHeight - 60,
        error: null,
        loading: false, // Added loading state
        course: null,
        title: "",
        instruction: "",
        time: null,
        pass_score: null


    };
    // for the image 
    fileInputRef = React.createRef();




    // start of the handle submition


    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState({ loading: true, error: null });
        const formData = new FormData();
        formData.append('course', this.state.course);
        formData.append('title', this.state.title);
        formData.append('description', this.state.instruction);
        formData.append('duration_minutes', this.state.time);
        formData.append('passing_score', this.state.pass_score);


        try {
            const accessToken = localStorage.getItem('accessToken');
            const response = await axios.post(`https://api.geoinfoacademy.com/api/tutor/exams/`, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            console.log('API response:', response);
            this.setState({
                course: null,
                title: "",
                instruction: "",
                time: null,
                pass_score: null,
                isActive: false
            });
            const formdisplay = document.querySelector(".dash_add_course_cover.addexam")
            formdisplay.style.display = "none"
        } catch (error) {
            console.error('Error submitting form:', error);
            // this.setState({error : "you didnt provide all the necessary information"})

        }
        finally {
            this.setState({ loading: false }); // Set loading to false after response
        }
    };


    // end for the submition


    // the display
    handleOutsideClick = (event) => {
        if (this.node && !this.node.contains(event.target)) {
            // this.setState({ isActive: false, });
            const formdisplay = document.querySelector(".dash_add_course_cover.addexam")
            formdisplay.style.display = "none"
        }

    };
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('mousedown', this.handleOutsideClick);
        if (this.props.course_id > 0) {
            console.log("course id in exam available on mount:", this.props.course_id);
            this.setState({
                course: this.props. course_id
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.course_id !== prevProps.course_id) {
            this.setState({
                course: this.props.course_id || null
            },);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }
    handleResize = () => {
        this.setState({ width: "100%", windowHeight: window.innerHeight - 60 });
    };


    render() {
        // const { menuCoverWidth } = this.state;
        console.log("add exam", this.state)
        return (

            <div className="dash_add_course_cover addexam"
                style={{ height: this.state.windowHeight }}
            >
                <div className="dash_form_container" ref={(node) => (this.node = node)}>
                    <h2>Add Exam</h2>
                    <p>Please specify the course for which you would like to create an exam</p>
                    <form className='add_course_form' onSubmit={this.handleSubmit}>
                        {/* <label htmlFor="course">Course Name</label><br />
                        <select name="course" id='course' value={this.state.course} onChange={this.handleInputChange} required>
                            <option value="">Select Course Name</option>
                            <option value="GIS">GIS</option>
                            <option value="Drone">Drone</option>
                            <option value="Survey">Survey</option>
                            <option value="Remote Sensing">Remote Sensing</option>
                        </select><br /><br /> */}
                        <label htmlFor="title">Title</label><br />
                        <input type="text" id='title' name="title" value={this.state.title} onChange={this.handleInputChange} placeholder="title" required /><br /><br />

                        <label htmlFor="instruction">Instruction</label><br />
                        <textarea type="text" id='instruction' name="instruction" value={this.state.instruction} onChange={this.handleInputChange} placeholder="Write instruction that the student should follow" required/> <br /><br />

                        <label htmlFor="time">Duration Time (min)</label><br />
                        <input type="number" id='time' name="time" value={this.state.time} onChange={this.handleInputChange} placeholder="20" min={1} required/><br /><br />

                        {/* <select name="time" id='time' value={this.state.time} onChange={this.handleInputChange} required>
                            <option value="">Select Time Limit</option>
                            <option value="15 minute">15 minute</option>
                            <option value="30 minute">30 minute</option>
                            <option value="45 minute">45 minute</option>
                            <option value="1 hour">1 hour</option>
                        </select><br /><br /> */}

                        <label htmlFor="pass_score">Pass Score</label><br />
                        <input type="number" id='pass_score' name="pass_score" value={this.state.pass_score} onChange={this.handleInputChange} placeholder="1 and above" min={1} /><br /><br />


                        <button type="submit" disabled={this.state.loading}>
                            {this.state.loading ? "Uploading..." : "Submit"}
                        </button>
                    </form>
                </div>
            </div>


        );
    }
}

export default AddExam;